<template>
  <base-section
    id="contact-us"
    class="hh-contact"
    space="96"
  >
    <v-container>
      <v-row
        align="center"
        justify="space-between"
      >
        <v-col
          cols="12"
          md="7"
        >
          <h2 class="hh-h2 hh-h2--compact mb-4">
            Have a project in mind? Let's talk.
          </h2>
          <p class="hh-lead mb-0">
            Tell us what you are building. We reply within one business day.
          </p>
        </v-col>

        <v-col
          cols="12"
          md="4"
        >
          <div class="hh-panel hh-contact__card">
            <div class="hh-contact__label mb-2">
              Email us
            </div>
            <a
              class="hh-contact__email"
              href="mailto:info@hackerhang.com?subject=Project%20inquiry"
            >info@hackerhang.com</a>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionContactUs',
  }
</script>

<style lang="sass">
  .hh-contact
    border-top: 1px solid var(--hh-line)
    background: radial-gradient(800px 400px at 100% 100%, rgba(232, 58, 240, .16), transparent 65%)

    &__card
      padding: 28px

    &__label
      font-size: .9rem
      color: var(--hh-muted)

    &__email
      display: block
      font-family: var(--hh-font-body)
      font-weight: 600
      font-size: 1.3rem
      color: var(--hh-cyan) !important
      text-decoration: none
      word-break: break-all
</style>
